// Centralizes where the auth token lives so "Remember me" actually does
// something: checked -> localStorage (survives browser close), unchecked ->
// sessionStorage (cleared when the browser/tab closes).

export const setToken = (key, value, remember) => {
    if (remember) {
        localStorage.setItem(key, value);
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.setItem(key, value);
        localStorage.removeItem(key);
    }
};

export const getToken = (key) => localStorage.getItem(key) || sessionStorage.getItem(key);

export const removeToken = (key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
};
